export enum ChartView {
  TVL = "TVL",
  VOL = "VOL",
  PRICE = "PRICE",
  FEES = "FEES",
  LIQUIDITY = "LIQUIDITY",
  TRANSACTIONS = "TRANSACTIONS",
  DexScreener = "DexScreener",
  APR = "APR",
  DexTools = "DexTools",
}
